import t from './translations';

export default {
    accountTypes: {
        player: 1,
        agent: 2,
        club: 3,
        manager: 7,
        master: 16,
        assistant: 4
    },
    accountTypeIds: {
        1: 'player',
        2: 'agent',
        3: 'club',
        7: 'manager',
        16: 'master',
        4: 'assistant'
    },
    clubRoles: {
      PLAYER: 'player',
      AGENT: 'agent',
      MANAGER: 'manager',
      OWNER: 'owner'
    },
    Products: {
        POKER: 'poker',
        SPORT: 'sport',
        CASINO: 'casino'
    },
    ProductFullNames: {
        5: 'Poker',
        8: 'SportsBook',
        9: 'Casino'
    },
    unionAllowedLevels: {
        create: 2,
        join: 2
    },
    gameTypes: {
        nlh: 1,
        plo4: 2,
        plo5: 10,
        capado: 36
    },
    gameTypeTitles: {
        1: "NLH",
        2: "PLO4",
        10: "PLO5",
        36: "CAPADO"
    },
    odds: {
      nlh: t.betYourHand.nlh,
      plo: t.betYourHand.plo
    },
    dimensions: {
        app: {
            width: 375,
            height: 710
        },
        slot: {
            width: 700,
            height: 500
        },
    },
    pokerLobbyStates: {
        NONE: 0,
        PENDING: 1,
        READY: 2,
    },
    smallBlinds: [ 0.1, 0.2, 0.3, 0.4, 0.5, 1, 2, 3, 4, 5, 7.5, 10, 15, 25, 50 ],
}
